export default __webpack_public_path__ + "static/media/calibra-cements-graphics.a476ba0c.svg";